import React, { useState } from "react";
import {
  Avatar,
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import { CloseIcon } from "../../../helper/Icons";
import CommonButton from "../../../components/common/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Upload_Product_modal = ({ handleClose, modalOpen }) => {
  const [fileName, setFileName] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };

  return (
    <>
      <DialogTitle sx={{ m: 0, p: 2 }} id="Common_modal">
        Upload Product
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ minWidth: { xs: "100%", sm: "500px" } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              sx={{ color: "#6b7280", marginBottom: "1.5rem" }}
            >
              Drag and drop a file here, or click the button below to select a file.
            </Typography>
            <Box
              sx={{

                
                border: "1px dashed #e5e7eb",
                padding: "1rem",
                borderRadius: "8px",
                cursor: "pointer",
                textAlign: "center",
                background: "#ffffff",
              }}
            >
              <input
                type="file"
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
              <CloudUploadIcon
                sx={{ fontSize: "3rem", color: "#4f46e5", marginBottom: "0.5rem" }}
              />
              <Typography variant="body2" sx={{ color: "#6b7280" }}>
                {fileName ? fileName : "Click to upload or drag file here"}
              </Typography>
            </Box>
            {fileName && (
              <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                <CheckCircleIcon
                  sx={{ color: "#22c55e", marginRight: "0.5rem" }}
                />
                <Typography variant="body2" sx={{ color: "#22c55e" }}>
                  {fileName} uploaded successfully!
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", padding: "1rem" }}>
        <CommonButton
          buttonName={"Upload"}
          onClick={() => console.log("Upload action triggered")}
        />
        <CommonButton
          buttonName={"Cancel"}
          onClick={handleClose}
          color="white"
          sx={{ ml: 2 }}
        />
      </DialogActions>
    </>
  );
};

export default Upload_Product_modal;
